export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, shrink-to-fit=no"}],"link":[{"rel":"apple-touch-icon","type":"image/png","sizes":"180x180","href":"/img/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/img/favicon-16x16.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/img/favicon-16x16.png","media":"(prefers-color-scheme: dark)"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/img/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/img/favicon-32x32.png","media":"(prefers-color-scheme: dark)"},{"rel":"icon","type":"image/png","sizes":"180x180","href":"/img/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/img/android-chrome-192x192.png"},{"rel":"icon","type":"image/png","sizes":"512x512","href":"/img/android-chrome-512x512.png"},{"rel":"stylesheet","href":"/bootstrap/css/bootstrap.min.css"}],"style":[],"script":[{"src":"/bootstrap/js/bootstrap.min.js","tagPosition":"bodyClose"},{"src":"/js/aos.min.js","tagPosition":"bodyClose"},{"src":"/js/bs-init.js","tagPosition":"bodyClose"},{"src":"/js/Lightbox-Gallery-baguetteBox.min.js","tagPosition":"bodyClose"},{"src":"/js/Lightbox-Gallery.js","tagPosition":"bodyClose"}],"noscript":[],"bodyAttrs":{"style":"color: #ffffff;background: rgb(0,0,0);font-family: Lexend, sans-serif;height: auto;overflow-x: clip;"},"htmlAttrs":{"data-bs-theme":"dark"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = true

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false